import axios from "axios";
import { API_ENDPOINTS, TRAINING_APP_URL } from "../../constants";
import axiosInstance from "../../core/apiService/webApiService";



const initiateTraining = async (payload: { question: string; sql: string }, token: string): Promise<any> => {
    const config = {
        headers: {
            Authorization: `Token ${token}`,
        },
    };

    const response = await axiosInstance.post(`${TRAINING_APP_URL}${API_ENDPOINTS.TRAINING.INITIATE_TRAINING_DATA}`, payload, config);
    return response.data;
};

const fetchTrainingData = async (payload:any,token: string): Promise<any> => {
    const config = {
        headers: {
            Authorization: `Token ${token}`,
        },
    };
const { searchQuery='', filterType='', pageNumber=1, pageSize=10 } = payload;
    const response = await axiosInstance.get(`${TRAINING_APP_URL}${API_ENDPOINTS.TRAINING.FETCH_TRAINING_DATA}?search=${searchQuery}&filter_by=${filterType}&page=${pageNumber}&page_size=${pageSize}`, config);
    return response.data;
};

const deleteTraining = async (payload: { training_id: string }, token: string): Promise<any> => {
    const config = {
        headers: {
            Authorization: `Token ${token}`,
        },
        data: payload,
    };

    const response = await axios.delete(`${TRAINING_APP_URL}${API_ENDPOINTS.TRAINING.DELETE_TRAINING_DATA}`, config);
    return response.data;
};

const updateTraining = async (payload: { training_id: string; question: string; sql: string }, token: string): Promise<any> => {
    const config = {
        headers: {
            Authorization: `Token ${token}`,
        },
    };

    const response = await axiosInstance.put(`${TRAINING_APP_URL}${API_ENDPOINTS.TRAINING.UPDATE_TRAINING_DATA}`, payload, config);
    return response.data;
};

const trainingService = {
    initiateTraining,
    fetchTrainingData,
    deleteTraining,
    updateTraining,
};

export default trainingService;
